<template>
    <Card :title="$t('labels.transfer')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6">
                    <FormGroup :label="$t('labels.warehouse_from')">
                        <AppAutoComplete
                            url="/management/warehouses"
                            :model-value="fromWarehouse?.uuid"
                            :selected-value="fromWarehouse?.name"
                            :query-params="{
                                ignore_uuids: [toWarehouse?.uuid]
                            }"
                            @update:model-value="fromWarehouse = $event"
                            can-be-empty
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-6">
                    <FormGroup :label="$t('labels.warehouse_to')">
                        <AppAutoComplete
                            url="/management/warehouses"
                            :model-value="toWarehouse?.uuid"
                            :selected-value="toWarehouse?.name"
                            :query-params="{
                                ignore_uuids: [fromWarehouse?.uuid]
                            }"
                            @update:model-value="toWarehouse = $event"
                            can-be-empty
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="indigo" @click="createTransfer" :disabled="!fromWarehouse || !toWarehouse">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.create') }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import AppAutoComplete from '../../../../components/new/form/autocomplete/AppAutoComplete.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';

import { httpClient } from '../../../../services/HttpClient';

export default {
    name: 'TransferCreatePage',
    components: {
        Card, FormGroup, AppAutoComplete, AppButton
    },
    data() {
        return {
            fromWarehouse: null,
            toWarehouse: null
        }
    },
    methods: {
        createTransfer() {
            httpClient.post(`/projects/${this.$route.params.projectUuid}/wms/transfers`, {
                warehouse_from_uuid: this.fromWarehouse?.uuid,
                warehouse_to_uuid: this.toWarehouse?.uuid
            }).then(response => {
                this.$router.push({ name: 'TransferEditPage', params: { transferUuid: response.data.data.uuid } });
            })
        }
    }
}
</script>